import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-foreground/10 bg-surface py-10 sm:py-14" data-id="element-206" data-mp="1tarjq9bipqkw">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 px-5 md:grid-cols-4 md:gap-y-0" data-id="element-207" data-mp="1obez7v84cvlh">
        {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-foreground/10' : ''}`} data-id="element-208" data-mp="1jb92i0mzsiwj" data-mpi={index}>
            <dt className="sr-only" data-id="element-209" data-mp="19lzd4sjj9ec4">{stat.label}</dt>
            <dd data-id="element-210" data-mp="19keeaqq6r98g">
              <span className="block font-display text-3xl font-black text-foreground sm:text-4xl" data-id="element-211" data-mp="15kx81v2xq828">
                {stat.value}
              </span>
              <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.16em] text-foreground/45 sm:text-[11px]" data-id="element-212" data-mp="10n4315ddbk3j">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}